// Libraries
import { Container, Flex, Image, Text } from '@chakra-ui/react';
import { ReactElement } from 'react';
// Assets
import topBanner from '@assets/images/top_banner.jpg';
// Types
import { BannerProps } from './Banner.type';

/**
 * Banner component.
 *
 * @component
 * @returns {ReactElement} The rendered Banner component.
 */
export const Banner = ({ user, logo }: BannerProps): ReactElement => {
  return (
    <Flex
      h={{ base: 25, md: 44 }}
      data-testid='banner'
      bgImage={`linear-gradient(89.92deg, rgba(3, 30, 41, 0.45) 36.77%, rgba(0, 0, 0, 0.06) 110.07%), url(${topBanner.src})`}
      bgSize='cover'
      bgPos='0 70%'
      w='full'
    >
      <Container maxW={384} verticalAlign='center' display='flex' alignItems='center' p={7}>
        {logo && <Image src={logo} alt='' display={{ base: 'none', md: 'block' }} h={8} mr={4} />}
        <Text fontSize={{ base: 'hs', md: 'hxl' }} fontWeight='medium' color='white'>
          {user ? `Welcome ${user.givenName} ${user.familyName}!` : 'Welcome!'}
        </Text>
      </Container>
    </Flex>
  );
};
